// extracted by mini-css-extract-plugin
export default {"container":"CourseLayout_container__29oe+","body":"CourseLayout_body__9QvsQ","main":"CourseLayout_main__hnMTH"};